export default function getHasCloudManagement() {
  // Cloud Management display logic dealt with externally
  return Promise.reject()
}
